// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"StoresList_contentComponent__3prQ9","search":"StoresList_search__ZY6uU","createButton":"StoresList_createButton__7mnCo","editIcon":"StoresList_editIcon__VuWVm"};